export default "__VITE_ASSET__B3Mk3tyX__"